import { CommonRepairerService } from '@savgroup-front-common/core/api/Repairer';

import getQuoteInfoByFileIdQuery from './getQuoteInfoByFileIdQuery';
import setQuoteClientAnswerCommand from './setQuoteClientAnswerCommand';

export const RepairerService = {
  getPendingCustomerValidationByFileId:
    CommonRepairerService.getPendingCustomerValidationByFileId,
  getQuoteInfoByFileIdQuery,
  setQuoteClientAnswerCommand,
};
